import { Form, Input } from 'antd';
import React, { FC } from 'react';
import { ISearchData } from 'shared/types/rvd.types';
import { SelectOptions } from '../..';
import style from './index.module.scss';

type TProps = {
  onSearch: (data: string, key: keyof ISearchData) => void;
};
const PositionName: FC<TProps> = ({ onSearch }) => {
  return (
    <Form.Item name={SelectOptions.PN_OPTION} className={style.searchInput}>
      <Input.Search
        placeholder="Поиск сотрудника по должности"
        allowClear
        onSearch={val => onSearch(val, 'positionName')}
      />
    </Form.Item>
  );
};

export default PositionName;
